import React from 'react';
import { DrawerContext } from './DrawerContext';

export type DrawerProviderProps = {
  open: boolean;
  children: React.ReactNode;
  onClose: (event: MouseEvent) => void;
};

const DrawerProvider = ({ open, onClose, children }: DrawerProviderProps): JSX.Element => {
  const contextProps = {
    open,
    onClose,
  };

  return <DrawerContext.Provider value={contextProps}>{children}</DrawerContext.Provider>;
};

export { DrawerProvider };
